export enum FiPublicationActionType {
    DeleteDocument = 1,
    UnpublishDocument = 2,
}
